import { useState } from 'react';
import { useMutation } from '@tanstack/react-query';
import { addManualCandidate } from '@/entities/outreach-candidate';
import type { ManualCandidateResult } from '../ui/ManualCandidateAdd';

/**
 * 직접 추가 — IA §3-3 「수동 추가」.
 *
 * **서버 문구를 그대로 보인다.** 「하나만 넣어 주세요」 같은 거절 사유는 서버가 판정한 것이고,
 * 화면이 다시 쓰면 두 문구가 갈린다.
 */
export function useManualCandidate(scenarioId: string) {
  const [result, setResult] = useState<ManualCandidateResult | null>(null);
  const [error, setError] = useState<string | null>(null);

  const mutation = useMutation({
    mutationFn: (input: string) => addManualCandidate(scenarioId, input),
    onSuccess: (row) => {
      setError(null);
      setResult({
        handle: row.handle,
        externalCreatorId: row.externalCreatorId,
        status: row.status,
      });
    },
    onError: (cause: { response?: { data?: { message?: string } } }) => {
      setResult(null);
      setError(cause.response?.data?.message ?? '후보를 더하지 못했습니다.');
    },
  });

  return {
    add: (input: string) => mutation.mutate(input),
    pending: mutation.isPending,
    result,
    error,
  };
}
